module.exports = __webpack_public_path__ + "static/flags/MY-05d8c324f005c7d71613a5585047d7da.gif";